import React from "react";
import "../../../assets/MB_UFGN_1/css/MB_UFGN_1.scss";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import Header from "../../Includes/Layouts/MB_UFGN_1/Header";
import FormMB_UFGN_1 from "../../Forms/FormMB_UFGN_1";
import Section1 from "../../Includes/Layouts/MB_UFGN_1/Section1";
import AccordSection from "../../Includes/Layouts/MB_UFGN_1/AccordSection";
import Footer from "../../Includes/Layouts/Common/Footer";
import FbViewPixel from "../../../Utility/FbViewPixel";
const MB_UFGN_1 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="MB_UFGN_1" />
      <FbViewPixel />
      <div className="MB_UFGN_1">
        <Header />
        <section className="form-part" id="firstform">
          <div className="container nopad">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 nopad">
              <FormMB_UFGN_1 />
            </div>
          </div>
        </section>
        <Section1 />
        <AccordSection />
        <Footer />
      </div>

    </>
  );
};
export default MB_UFGN_1;